var e={exports:{}};export{e as __module};
//# sourceMappingURL=performance-now.js.map
